import { render, staticRenderFns } from "./IconCommoChat.vue?vue&type=template&id=42960080"
import script from "./IconCommoChat.vue?vue&type=script&lang=js"
export * from "./IconCommoChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports